import api from "@/core/services/api.service";

const sportService = {

    getModalidades(params) {
        api.setHeader()
        return api.post("api/sport/modalidades", params)
    },
    
    getDivisiones(params) {
        api.setHeader()
        return api.post("api/sport/divisiones", params)
    },

    getSubDivisiones(params) {
        api.setHeader()
        return api.post("api/sport/subdivisiones", params)
    },

}

export default sportService